export const PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT = {
    CONSTRUCTION_READY: "Gotowe",
    EMPTY_VALUE_LINES: ["Informacja\u00A0u", "dewelopera"] as const,
    GROUND_FLOOR: "Parter",
    ROW_LABELS: {
        additional_areas: "Powierzchnie dodatkowe",
        area: "Metraż",
        construction_end_date: "Termin oddania",
        floor: "Piętro",
        floors: "Kondygnacje",
        kitchen: "Kuchnia",
        quarters: "Strona świata",
        rooms: "Pokoje"
    }
} as const;

export type PropertyCardDetailInfoTableRowKey = keyof typeof PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT.ROW_LABELS;

export const PROPERTY_CARD_DETAIL_INFO_TABLE_ROW_KEYS: PropertyCardDetailInfoTableRowKey[] = [
    "rooms",
    "area",
    "floor",
    "construction_end_date",
    "floors",
    "quarters",
    "kitchen",
    "additional_areas"
];

export const getPropertyCardDetailInfoTableRowLabel = (rowKey: PropertyCardDetailInfoTableRowKey) => PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT.ROW_LABELS[rowKey];
export const PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT = {
    CONSTRUCTION_READY: "Gotowe",
    EMPTY_VALUE_LINES: ["Informacja\u00A0u", "dewelopera"] as const,
    GROUND_FLOOR: "Parter",
    ROW_LABELS: {
        additional_areas: "Powierzchnie dodatkowe",
        area: "Metraż",
        construction_end_date: "Termin oddania",
        floor: "Piętro",
        floors: "Kondygnacje",
        kitchen: "Kuchnia",
        quarters: "Strona świata",
        rooms: "Pokoje"
    }
} as const;

export type PropertyCardDetailInfoTableRowKey = keyof typeof PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT.ROW_LABELS;

export const PROPERTY_CARD_DETAIL_INFO_TABLE_ROW_KEYS: PropertyCardDetailInfoTableRowKey[] = [
    "rooms",
    "area",
    "floor",
    "construction_end_date",
    "floors",
    "quarters",
    "kitchen",
    "additional_areas"
];

export const getPropertyCardDetailInfoTableRowLabel = (rowKey: PropertyCardDetailInfoTableRowKey) => PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT.ROW_LABELS[rowKey];
